<template>
    <div id="contact">
    <div class="contact">
        <div class="container">
            <div class="contact-main ">
                <div class="contact-top wow fadeInUp" data-wow-delay="0.3s">
                    <h3>
                     <img class="left_border" src="./img/border2.png">{{$t("contact.title")}}<img class="right_border" src="./img/border2.png">
                    </h3>
                    <span class="heading-line"></span>
                    <p>{{$t("contact.title_text")}}</p>
                </div>
                <div class="row">
                <div class="contact-bottom">
                    <div class="col-md-6 contact-left wow fadeInLeft" data-wow-delay="0.8s">
                            <input type="text" v-model="name" :placeholder="$t('contact.name')">
                            <input type="text" v-model="email" :placeholder="$t('contact.email')">
                            <textarea :placeholder="$t('contact.message')" v-model="message"></textarea>
                            <input type="submit" :value="$t('contact.send')" @click="submit()">
                    </div>
                    <div class="col-md-6 contact-right wow fadeInRight" data-wow-delay="0.8s">
                        <h4>{{$t("contact.contactinfo")}}</h4>
                        <ul>
                            <li><i class="fa fa-building fa-lg"></i>{{$t("contact.address")}}</li>
                            <li><i class="fa fa-envelope fa-lg"></i>
                                info<img class="at" src="./img/at.png"/>eachcloud.io
                            </li>
                        </ul>
                        <div class="qr_code_wrapper">
                            <img class="ec-img-erweima" alt="扫描二维码,关注亿企云!" src="./img/qrcode-eachcloud.jpg" />
                            <span class="qr_code_title">{{$t("contact.qrcode")}}</span>
                            <div class="arrows_wrapper">
                                <img class="arrows" src="./img/arrows.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data() {
            return {
                info: {}, // contact info
                name: undefined,
                email: undefined,
                message: undefined,
                username:'dceL0AgHGPjiUB84yTBSew',
                password: 'F25MVoNYG5Mk1RDO5daSDg'
            }
        },
        mounted() {},
        props:[],
        methods: {
            submit() {
                // window.alert('name: ' + this.name);
                var that = this;
                $.ajax({
                    type: 'POST',
                    url: 'https://jinshuju.net/api/v1/forms/B5cCPm',
                    data: JSON.stringify({"field_1": this.name, "field_2": this.email, "field_3": this.message}),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function(data) {alert(that.$t('contact.received'));},
                    failure: function (errMsg) {alert(errMsg);},
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("Authorization", "Basic " + btoa('dceL0AgHGPjiUB84yTBSew:F25MVoNYG5Mk1RDO5daSDg'));
                    }
                })
            }
        }
    }
</script>
<style>
#contact {
    padding-top: 70px;
    margin-top: -70px;
    /*height: 90vh;*/
}
#contact {
    font-size: 15px;
}
.contact {
    background: url(./img/contact-bg.jpg) no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    /*min-height: 500px;*/
    padding-bottom:14em;
    background-position: right;
}
.contact-left input[type="text"] {
    font-size: 1.0em;
    color: #F1F1F1;
    padding: 0.8em 1em;
    width: 100%;
    margin-bottom: 1.5em;
    border: 1px solid #fff;
    border-radius: 5px;
    outline: none;
    background: none;
}
.contact-left textarea {
    font-size: 1.0em;
    color: #F1F1F1;
    padding: 0.8em 1em;
    width: 100%;
    margin-bottom: 0.5em;
    border: 1px solid #fff;
    outline: none;
    resize: none;
    height: 10em;
    border-radius: 5px;
    background: none;
}
.contact-left input[type="submit"] {
    font-size: 1.0em;
    color: #fff;
    background: #ba7b7b;
    border: none;
    padding: 0.8em 1.5em;
    outline: none;
    border-radius: 5px;
    margin-top: 1em;
}
.contact-left input[type="submit"]:hover{
    background: #006e96;
    transition: 0.5s all;
    --webkit-transition: 0.5s all;
    --moz-transition: 0.5s all;
}
.contact-top {
    padding-top:20px;
    /*margin-top: 30px;*/
    margin-bottom: 30px;
    font-weight: bold;
}
.contact-top h3 {
    font-size: 2em;
    color: #fff;
    text-align: center;
    font-family: 'Oswald',sans-serif;
}
.contact-top p {
    font-size: 1.5em;
    color: #e8ddaf;
    text-align: center;
}
.contact-right h4 {
    font-size: 1.5em;
    color: #fff;
    text-align: left;
    margin-bottom: 0.5em;
    font-family: 'Oswald',sans-serif;
}
.contact-right ul {
    padding: 0px;
    list-style: none;
    margin-top: 1em;
    font-size: 1.5em;
    text-align: left;
}
.contact-right ul li {
    padding-bottom: 14px;
    color: #fff;
}
.contact-right ul li a {
    color: #fff;
}
.contact-right ul li a:hover{
    color: #006e96;
}
input::placeholder, textarea::placeholder {
    color: #ededed;
}
i {
    font-size: 1.3em;
    color: #fff;
    margin-right: 0.5em;
    vertical-align: text-top;
}
.qr_code_wrapper {
    text-align: center;
    width: 160px;
    height: 180px;
    background-color: white;
    position: relative;
}
.ec-img-erweima {
    width: 140px;
    height: 140px;
    margin: 10px 10px 0 10px;
}
.qr_code_title {
    color: #736D6D;
    font-size: 12px;
    margin-top: 8px;
    display: inline-block;
}
.arrows_wrapper {
    width: 100px;
    position: absolute;
    top: 0;
    left: 180px;
    transform: rotate(200deg);
    -ms-transform: rotate(200deg);
    -webkit-transform: rotate(200deg);
}
.left_border {
    display: inline-block;
    width: 60px;
    margin-right: 50px;
}
.right_border {
    display: inline-block;
    width: 60px;
    margin-left: 40px;
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
}
@media only screen and (max-width: 768px) {
    .contact-top p{
        font-size: 15px;
    }
    .left_border,.right_border {
        display: none;
    }
}
.at {
    width: 0.8em;
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue